import { type MouseEvent, type ReactNode } from 'react';
import {
    SelectedValuePills,
    type SelectedPillEntry,
} from '../../../_utils/components';
import { type SelectedPillItem } from '../../../_utils/MultiSelectChip.utils';

interface MultiSelectSelectedPillsProps {
    items: SelectedPillItem[];
    onDismiss: (value: unknown, event: MouseEvent<HTMLButtonElement>) => void;
    disabled?: boolean;
}

function toSelectedPillEntry(
    item: SelectedPillItem,
): SelectedPillEntry<unknown> {
    return { id: String(item.value), label: item.label, value: item.value };
}

export function MultiSelectSelectedPills({
    items,
    onDismiss,
    disabled,
}: MultiSelectSelectedPillsProps): ReactNode {
    return (
        <SelectedValuePills
            entries={items.map(toSelectedPillEntry)}
            wrapperClassName="ics-multiselect__pills"
            pillClassName="ics-multiselect__pill"
            pillLabelClassName="ics-multiselect__pill-label"
            onDismiss={onDismiss}
            disabled={disabled}
        />
    );
}
